import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import { useMutation } from 'react-apollo';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import ReactImageFallback from 'react-image-fallback';
import {
  UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Button,
} from 'reactstrap';
import LoadingOverlay from 'react-loading-overlay';
import { useInfiniteScroll } from 'react-infinite-scroll-hook';
import { map } from 'lodash';
import moment from 'moment';
import { InviteArtistModal, SeeContract, DeleteOffer } from '../../../modals';
import {
  dateFormats, OFFER_ICON, FALLBACK_ICON, routeConstants, loaderStyle, OFFER_TYPE, history,
  handleGraphqlError,
  NUMERIC_VALUE,
  renderDateRange,
  Messages,
  staticConstants,
} from '../../../../utils';
import {
  useChatMessageInitializer,
} from '../../../../utils/chatMessageInitializer';
import { INVITE_ARTIST, LOADER_MUTATION } from '../../../../graphql-client/mutations';

function renderParticipantArtistList(participantList) {
  if (participantList.length) {
    return map(participantList, (item, index) => item && index < NUMERIC_VALUE.FIVE && (
      <>
        <span
          key={Math.random()}
          data-tip={item.userId.name}
          data-place="bottom"
          data-background-color="#fff"
          data-text-color="#000"
        >
          <ReactImageFallback
            src={item.userId.artistImage}
            fallbackImage={FALLBACK_ICON}
            className="image-cover"
            alt="User"
          />
        </span>
        <ReactTooltip effect="solid" />
      </>
    ));
  }
  return null;
}

function renderArtistListOnHover(participantList) {
  return map(participantList, (item, index) => item && `${index + NUMERIC_VALUE.ONE}` > NUMERIC_VALUE.SIX && (
    <div className="admin-card-footer-users-count-row" key={Math.random()}>
      <span>
        <ReactImageFallback
          src={item.userId.artistImage}
          fallbackImage={FALLBACK_ICON}
          className="image-cover"
          alt="User"
        />
      </span>
      <p>{item.userId.name}</p>
    </div>
  ));
}

function OfferListing(props) {
  useChatMessageInitializer();
  const { addToast } = useToasts();
  const {
    offerData, loading, handleInfiniteScroll, currentPage, onDeleteOfferCallback,
    hasUnreadMessage, isSearchApplied,
  } = props;
  const [existingOfferList, setExistingOfferList] = useState([]);
  const [inviteArtistModal, setInviteArtistModal] = useState(false);
  const [isSeeContractModal, setSeeContractModal] = useState(false);
  const [isDeleteOfferModal, setDeleteOfferModal] = useState(false);
  const [contractData, setContractData] = useState();
  const [categoriesData, setCategoriesData] = useState();
  const [basePrice, setBasePrice] = useState();
  const [targetAudience, setTargetAudience] = useState();
  const [offerId, setOfferId] = useState();
  const [viewType, setViewType] = useState();

  const toggleInviteArtistModal = (selectedOfferData) => {
    setCategoriesData(selectedOfferData.categories);
    setBasePrice(selectedOfferData.basePrice);
    setOfferId(selectedOfferData._id);
    setTargetAudience(selectedOfferData.targetAudience);
    setInviteArtistModal(!inviteArtistModal);
    setViewType(selectedOfferData.viewType);
  };

  const toggleSeeContractModal = (selectedOffer) => {
    setContractData(selectedOffer);
    setSeeContractModal(!isSeeContractModal);
  };

  const toggleDeleteOfferModal = (selectedId) => {
    setOfferId(selectedId);
    setDeleteOfferModal(!isDeleteOfferModal);
  };

  const [loaderMutate] = useMutation(LOADER_MUTATION, {
    variables: {},
  });

  const [inviteArtist] = useMutation(INVITE_ARTIST, {
    variables: {},
    onError(err) {
      loaderMutate({ variables: { show: false } });
      addToast(handleGraphqlError(err), { appearance: 'error' });
    },

    onCompleted(inviteData) {
      loaderMutate({ variables: { show: false } });
      addToast(inviteData.inviteArtists.message, { appearance: 'success' });
    },

  });

  const onInviteArtist = (queryObj) => {
    queryObj.offerId = offerId;
    inviteArtist({ variables: queryObj });
    loaderMutate({ variables: { show: false } });
  };

  useEffect(() => {
    if (offerData && offerData.data && offerData.data.length > 0) {
      const dataList = offerData.data;
      (currentPage === NUMERIC_VALUE.ONE && isSearchApplied) && window.scrollTo(0, 0);
      setExistingOfferList(currentPage === NUMERIC_VALUE.ONE ? dataList : existingOfferList.concat(dataList));
    } else if (offerData && offerData.count !== 0 && offerData.data.length === 0) {
      setExistingOfferList([]);
    }
  }, [offerData]);

  const viewOfferDetail = (offerObj) => {
    const routeToRedirect = offerObj.isPublish
      ? `${routeConstants.OFFER_DETAIL}/${offerObj._id}`
      : `${routeConstants.EDIT_OFFER}/${offerObj._id}`;
    history.push({ pathname: routeToRedirect, state: { isOfferListing: true } });
  };

  const renderOfferList = () => {
    if (offerData) {
      const baseUrl = window.location.host;
      return map(existingOfferList, (item) => {
        const registerDate = moment(item.createdAt).format(dateFormats.DATE_WITH_YEAR);
        const endDeadlineDate = moment(item.endDeadline).format(dateFormats.DATE_WITH_YEAR);
        const dateInterval = moment(item.offerMaxDate).diff(moment(), 'minutes');
        const offerStartInterval = item.offerMinDate && moment(item.offerMinDate).diff(moment(), 'minutes');
        const { isNotification } = item;
        const copyToClipAction = () => {
          addToast(Messages.copyLinkSuccess, { appearance: 'success' });
        };
        return item && (
          <div className={`admin-card ${(dateInterval <= 0 && item.isPublish) ? 'passed-card' : ''}`} key={Math.random()}>
            {
              item.isPublish && (
                <div className="copy-url-container" onClick={(e) => { e.stopPropagation(); }}>
                  <CopyToClipboard text={`${baseUrl}${routeConstants.DASHBOARD}?offerId=${item._id}`} onCopy={copyToClipAction}>
                    <span className="copy-url-btn" />
                  </CopyToClipboard>
                  <span className="copy-url-text">Copy URL</span>
                </div>
              )
            }
            <div className="admin-card-content" onClick={() => { viewOfferDetail(item); }}>
              <div className="admin-card-content-cover">
                <img src={item.coverImage} alt="Cover" />
              </div>
              <div className="admin-card-head">
                {
                  !item?.isClientLogoHide
                    ? (
                      <div className="admin-card-head-image">
                        <ReactImageFallback
                          src={item.clientLogo}
                          fallbackImage={FALLBACK_ICON}
                          className="image-cover"
                          alt="Offer"
                        />
                      </div>
                    )
                    : (
                      <div className="admin-card-head-image transparent-background border-0" />
                    )
                }

                <div className="admin-card-head-detail">
                  <p className="expired-tag">{(dateInterval <= 0 && item.isPublish) && 'Expired'}</p>
                  <p>{item.clientName}</p>
                  <h2>{item.title}</h2>
                  <span>{OFFER_TYPE[item.campaignType]}</span>
                  <span className={`ml-1 ${item.viewType === staticConstants.STATUS_TYPE.PUBLIC ? 'mx-1' : ''}`}>{OFFER_TYPE[item.viewType]}</span>
                  {
                    item.viewType === staticConstants.STATUS_TYPE.PUBLIC
                    && <span className="ml-0">{OFFER_TYPE[item.gigType]}</span>
                  }
                  <em>{renderDateRange(item.offerMinDate, item.offerMaxDate)}</em>
                </div>
              </div>
              <div className="admin-card-body">
                <p>
                  {item.description}
                </p>
                <span className="admin-card-body-date">{`Created on ${registerDate}`}</span>
                <span className="admin-card-body-date">{`Offer deadline ${endDeadlineDate}`}</span>
              </div>
              <div className="admin-card-footer">
                <div className="admin-card-footer-users">
                  {item.isPublish ? (
                    <>
                      {renderParticipantArtistList(item.participatingArtist)}
                      {
                        item.participatingArtist.length > NUMERIC_VALUE.SIX
                        && (
                          <div className="admin-card-footer-users-count">
                            {item.participatingArtist.length > NUMERIC_VALUE.SIX
                              && `+${item.participatingArtist.length - NUMERIC_VALUE.SIX} Participating Artists`}
                            <div className="admin-card-footer-users-count-list">
                              {renderArtistListOnHover(item.participatingArtist)}
                            </div>
                          </div>
                        )
                      }
                      <em
                        className={`admin-card-footer-icon icon-message ml-auto ${classnames({
                          active: hasUnreadMessage(item._id),
                        })}`}
                      />
                      <em
                        className={`admin-card-footer-icon icon-notification ml-3 ${classnames({
                          active: isNotification,
                        })}`}
                      />
                    </>
                  ) : (
                    <Button
                      type="button"
                      color="publish"
                      size="md"
                      className="ml-auto"
                    >
                      Publish opportunity
                    </Button>
                  )}
                </div>
              </div>
            </div>
            <UncontrolledDropdown>
              <DropdownToggle>
                <span className="toggle-icon" />
              </DropdownToggle>
              <DropdownMenu right className="dropdown-theme card-dropdown">
                {item.isPublish && (
                  <>
                    {(dateInterval > 0 && offerStartInterval > 0)
                      && (
                        <DropdownItem
                          onClick={() => { item && toggleInviteArtistModal(item); }}
                        >
                          Invite Artists
                        </DropdownItem>
                      )}
                    <DropdownItem
                      onClick={() => { item.createContract && toggleSeeContractModal(item); }}
                    >
                      See contract
                    </DropdownItem>
                  </>
                )}
                <Link
                  to={{
                    pathname: `${routeConstants.EDIT_OFFER}/${item && item._id}`,
                    state: { isOfferListing: true },
                  }}
                >
                  <DropdownItem>
                    Edit
                  </DropdownItem>
                </Link>
                <DropdownItem
                  className="text-danger"
                  onClick={() => { item && toggleDeleteOfferModal(item._id); }}
                >
                  Delete
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        );
      });
    }
    return null;
  };

  function handleLoadMore() {
    handleInfiniteScroll(currentPage + NUMERIC_VALUE.ONE, NUMERIC_VALUE.FIVE);
  }

  const infiniteRef = useInfiniteScroll({
    loading,
    hasNextPage: offerData && offerData.hasNextData,
    onLoadMore: handleLoadMore,
    scrollContainer: 'window',
  });

  return (
    <>
      <div className="content-wrapper-box">
        <LoadingOverlay
          active={loading}
          spinner
          text=""
          className="offerListContainerLoader"
          styles={loaderStyle}
        />
        <div ref={infiniteRef}>
          <div className="admin-card-wrapper">
            {renderOfferList()}
          </div>

          {offerData && offerData.count === 0 && (
            <div className="no-offer-section">
              <div className="no-offer-content d-block">
                <img
                  src={OFFER_ICON}
                  alt="Offer"
                />
                <h1>No opportunity yet!</h1>
                <p>Start creating opportunities and assign campaigns to Artists.</p>
                <Link
                  to={`${routeConstants.CRETAE_OFFER}`}
                  className="btn btn-add"
                >
                  + New opportunity
                </Link>
              </div>
            </div>
          )}

          {offerData && offerData.count !== 0 && offerData.data.length === 0 && (
            <div className="no-offer-content">
              <div className="no-table-data">
                <h2>No Results found</h2>
                <p>Try using a different name or keyword</p>
              </div>
            </div>
          )}
        </div>
      </div>
      {inviteArtistModal && (
        <InviteArtistModal
          isOpen={inviteArtistModal}
          onClose={() => { toggleInviteArtistModal(categoriesData); }}
          publishAndInviteOffer={onInviteArtist}
          categoriesData={categoriesData}
          basePrice={basePrice}
          isInviteOnly
          offerId={offerId}
          targetAudience={targetAudience}
          isPrivateType={viewType === staticConstants.STATUS_TYPE.PRIVATE}
        />
      )}
      {isSeeContractModal && (
        <SeeContract
          isOpen={isSeeContractModal}
          onClose={() => { toggleSeeContractModal(); }}
          offerData={contractData}
        />
      )}

      {isDeleteOfferModal && (
        <DeleteOffer
          isOpen={isDeleteOfferModal}
          onClose={() => { toggleDeleteOfferModal(offerId); }}
          offerId={offerId}
          deleteOffer={() => { onDeleteOfferCallback(offerId); }}
        />
      )}
    </>
  );
}
OfferListing.propTypes = {
  offerData: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({
      _id: PropTypes.string,
      title: PropTypes.string,
      clientName: PropTypes.string,
      isNotification: PropTypes.bool,
      campaignType: PropTypes.string,
      viewType: PropTypes.string,
      description: PropTypes.string,
      clientLogo: PropTypes.string,
      targetAudience: PropTypes.object,
      campaignTimeline: PropTypes.arrayOf(PropTypes.shape({
        startDate: PropTypes.string,
        endDate: PropTypes.string,
        description: PropTypes.string,
        shareType: PropTypes.shape({
          facebook: PropTypes.bool,
          instagram: PropTypes.bool,
          twitter: PropTypes.bool,
          youtube: PropTypes.bool,
          spotify: PropTypes.bool,
        }),
      })),
      createContract: PropTypes.string,
      createdAt: PropTypes.string,
      participatingArtist: PropTypes.arrayOf(PropTypes.shape({
        userId: PropTypes.shape({
          name: PropTypes.string,
          artistImage: PropTypes.string,
        }),
      })),
    })),
    count: PropTypes.number,
    hasNextData: PropTypes.bool,
  }),
  loading: PropTypes.bool.isRequired,
  handleInfiniteScroll: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  onDeleteOfferCallback: PropTypes.func.isRequired,
  hasUnreadMessage: PropTypes.func.isRequired,
  isSearchApplied: PropTypes.bool.isRequired,
};

OfferListing.defaultProps = {
  offerData: null,
};

export default OfferListing;
